import styled from 'styled-components/macro';
import * as RadixDropdown from '@radix-ui/react-dropdown-menu';
import {
  BaseContent,
  BaseItem,
  BaseSubTrigger,
  BaseSubContent,
  BaseSeparator,
  BaseCheckboxItem,
  BaseIndicator,
} from '../menu.styled';
import {
  menuSlideInBottom,
  menuSlideInLeft,
  menuSlideInRight,
  menuSlideInTop,
  menuSlideOutBottom,
  menuSlideOutLeft,
  menuSlideOutRight,
  menuSlideOutTop,
} from '../menu.animations';

export const StyledContent = styled(RadixDropdown.Content)`
  ${BaseContent};
  min-width: var(--radix-dropdown-menu-trigger-width);
  max-width: var(--radix-dropdown-menu-content-available-width);
  max-height: var(--radix-dropdown-menu-content-available-height);
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);

  &[data-state='open'] {
    &[data-side='top'] {
      animation-name: ${menuSlideInTop};
    }
    &[data-side='right'] {
      animation-name: ${menuSlideInRight};
    }
    &[data-side='bottom'] {
      animation-name: ${menuSlideInBottom};
    }
    &[data-side='left'] {
      animation-name: ${menuSlideInLeft};
    }
  }

  &[data-state='closed'] {
    &[data-side='top'] {
      animation-name: ${menuSlideOutTop};
    }
    &[data-side='right'] {
      animation-name: ${menuSlideOutRight};
    }
    &[data-side='bottom'] {
      animation-name: ${menuSlideOutBottom};
    }
    &[data-side='left'] {
      animation-name: ${menuSlideOutLeft};
    }
  }
`;

export const StyledSubTrigger = styled(RadixDropdown.SubTrigger)`
  ${BaseSubTrigger};
`;

export const StyledSubContent = styled(RadixDropdown.SubContent).attrs({
  sideOffset: 12,
  collisionPadding: 16,
})`
  ${BaseSubContent};
  max-width: var(--radix-dropdown-menu-content-available-width);
  max-height: var(--radix-dropdown-menu-content-available-height);
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);

  &[data-state='open'] {
    &[data-side='top'] {
      animation-name: ${menuSlideInTop};
    }
    &[data-side='right'] {
      animation-name: ${menuSlideInRight};
    }
    &[data-side='bottom'] {
      animation-name: ${menuSlideInBottom};
    }
    &[data-side='left'] {
      animation-name: ${menuSlideInLeft};
    }
  }

  &[data-state='closed'] {
    &[data-side='top'] {
      animation-name: ${menuSlideOutTop};
    }
    &[data-side='right'] {
      animation-name: ${menuSlideOutRight};
    }
    &[data-side='bottom'] {
      animation-name: ${menuSlideOutBottom};
    }
    &[data-side='left'] {
      animation-name: ${menuSlideOutLeft};
    }
  }
`;

export const StyledItem = styled(RadixDropdown.Item).attrs<{
  disabled?: boolean;
}>(({ disabled, onClick, onSelect, ...props }) => ({
  ...props,
  onClick: disabled
    ? (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
      }
    : onClick,
  onSelect: disabled
    ? (e: Event) => {
        e.preventDefault();
      }
    : onSelect,
}))`
  ${BaseItem};
`;

export const StyledSeparator = styled(RadixDropdown.Separator)`
  ${BaseSeparator};
`;

export const StyledCheckboxItem = styled(RadixDropdown.CheckboxItem)`
  ${BaseCheckboxItem};
`;

export const StyledItemIndicator = styled(RadixDropdown.ItemIndicator)`
  ${BaseIndicator};
`;
